var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalRobi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7686 22V40.5044L42.4619 48.3901L28 56.7597L43.9991 65.9835L59.2582 57.1868V39.5934L28.7686 22Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5352 56.7596L43.997 65.1293V48.4185L29.5352 56.7596Z",
    fill: "#ED3B7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5352 23.3376V40.0485L43.997 31.6788L29.5352 23.3376Z",
    fill: "#FCB832"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.997 31.679L29.5352 40.0486L43.997 48.4182V31.679Z",
    fill: "#F79420"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4903 56.7598V40.0488L44 48.4186L58.4903 56.7598Z",
    fill: "#7B1B66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44 48.4182L58.4903 40.0486L44 31.679V48.4182Z",
    fill: "#F05A22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4903 56.7596L44 48.4185V65.1293L58.4903 56.7596Z",
    fill: "#C30C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalRobi);
export default __webpack_public_path__ + "static/media/logoModalRobi.c394c3c248adc8c7f0f0323a9d60fe0b.svg";
export { ForwardRef as ReactComponent };